import { createContext, type ReactNode, useContext, useState } from 'react';
import type { SoQuyTienMatRequest } from '@/types/schemas';
import { useSoQuyTienMatExport } from './hooks';

interface SoQuyTienMatContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  isExporting: boolean;
  setExportBody: (body: Partial<SoQuyTienMatRequest>) => void;
}

const SoQuyTienMatContext = createContext<SoQuyTienMatContextValue | null>(null);

export const useSoQuyTienMatContext = () => {
  const context = useContext(SoQuyTienMatContext);
  if (!context) {
    throw new Error('useSoQuyTienMatContext must be used within SoQuyTienMatProvider');
  }
  return context;
};

export const SoQuyTienMatProvider = ({ children }: { children: ReactNode }) => {
  const [exportBody, setExportBody] = useState<Partial<SoQuyTienMatRequest> | undefined>(undefined);
  const { exportToExcel, canExport, isExporting } = useSoQuyTienMatExport(exportBody);

  return (
    <SoQuyTienMatContext.Provider value={{ exportToExcel, canExport, isExporting, setExportBody }}>
      {children}
    </SoQuyTienMatContext.Provider>
  );
};
